<template>
  <div class="dt-page">
    <div class="t1"></div>
    <div class="t2"></div>
    <div class="faceType">{{ info.faceInType == 1 ? '到校' : '离校' }}</div>
    <div class="tt">
      <div class="btn" @click="gotoList">
        <div>历史记录</div>
        <van-icon name="arrow" color="#BBB" style="margin-left: 2px" />
      </div>
    </div>
    <div class="tb">
      <div
        class="l1"
        :style="`background-image: url('${info.faceUrl}')`"
        @click="prewView(info.faceUrl)"
      ></div>
      <div class="l3 flex-center">
        <div class="l30"></div>
        <div>
          <div class="l31">{{ info.studentName }}已{{ info.faceInType == 1 ? '签到' : '签退' }}！</div>
          <div class="l32">
            {{ info.faceInFullTime | formatDatetime('yyyy-MM-dd hh:mm') }}
          </div>
        </div>
      </div>
      <div class="l4">{{ info.companyName }}-{{ info.campusName }}</div>
    </div>
    <div class="tf1" @click="toShare">
      <span class="tf11">希望其他机构也使用这个功能？</span>
      <span class="tf11">把“脸到”推荐给老师吧，机构家长都免费，老师孩子都放心~</span
      ><span class="tf12">立即分享</span>
    </div>
  </div>
</template>

<script>
export default {
  mixins: [app.mixin.share],
  data() {
    return {
      pageTitle: '签到/退记录',
      info: {},
      // 如果是点击推送进入则为1
      faceScene: this.$vxRoute.query.faceScene || 0,
      id: this.$vxRoute.params.id,
    };
  },
  methods: {
    gotoList() {
      if (this.faceScene == 1) {
        this.$router.push('/face/home/0');
      } else {
        this.$router.back();
      }
    },
    prewView(imgurl) {
      vant.ImagePreview({
        closeable: false,
        showIndex: false,
        images: [imgurl],
      });
    },
    toShare() {
      // 展示弹窗提示
      app.x3.popup.share();
    },
    setShare() {
      let slink = `${location.origin}/app/simple${location.search}#/face-poster`;
      this.app_share_resolve({
        title: `${this.info.studentName}的家长推荐你免费使用脸到APP！`,
        desc: '孩子刷脸签到，家长自动收到消息，我们都放心。',
        link: slink,
        imgUrl: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/face/logo.png',
      });
    },
  },
  async created() {
    let res = await this.$api.getFaceInRecordDetail({
      id: this.id,
    });
    this.info = res.data;
    this.setShare();
  },
};
</script>

<style lang="scss" scoped>
.dt-page {
  background: #1952e1;
  .t1 {
    position: absolute;
    top: 49px;
    left: 0;
    width: 20.8vw;
    height: 20.8vw;
    background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/face/010.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: -1;
  }
  .t2 {
    position: absolute;
    top: 49px;
    right: 0;
    width: 20.8vw;
    height: 20.8vw;
    background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/face/011.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .faceType {
    position: absolute;
    top: 55px;
    left: 0;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 40);
    background: var(--white);
    font-size: var(--fs-ex1);
    line-height: var(--lh-ex1);
    transform: translatex(-5px) rotatez(-30deg);
  }
  .tb {
    width: 86.6vw;
    margin: 26px auto 0 auto;
    padding-top: 8vw;
    padding-bottom: 2.6vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    z-index: 5;
    background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/face/013.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: 0 0;
    .l1 {
      width: 81.5vw;
      height: 75vw;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
    .l3 {
      position: relative;
      margin-top: 18px;
      .l30 {
        width: 17vw;
        height: 17vw;
        margin-right: 2px;
        background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/face/012.png');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: 0 0;
      }
      .l31 {
        position: relative;
        font-size: 20px;
        font-weight: 500;
        color: var(--g8);
        line-height: 28px;
      }
      .l32 {
        font-size: 14px;
        line-height: 20px;
        color: var(--g6);
      }
    }
    .l4 {
      margin-top: 22px;
      color: var(--g6);
      line-height: 20px;
    }
  }
  .tf1 {
    padding-left: 16px;
    padding-right: 16px;
    margin-top: 22px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    .tf11 {
      opacity: 0.49;
    }
    .tf12 {
      margin-left: 8px;
      text-decoration: underline;
    }
  }
  .tt {
    display: flex;
    justify-content: flex-end;
    .btn {
      margin-top: 18px;
      width: 92px;
      height: 30px;
      display: flex;
      align-items: center;
      padding-left: 18px;
      font-size: var(--fs-sm);
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
      border-radius: 100px 0px 0px 100px;
      background-color: rgba(255, 255, 255, 0.1);
      color: var(--white);
      z-index: 2;
      .icon {
        margin-left: 4px;
        margin-right: 4px;
      }
    }
  }
}
</style>